import React, { Component } from "react";
import { Link } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Navbar from "./Navbar";

const JobListings = ({ listings }) => {
  return (
    <div>
      {listings.map(listing => (
        <div key={listing.id}>
          <Link to={`/careers/${listing.id}`}>{listing.title}</Link>
          <div className="text-muted">{listing.location}</div>
        </div>
      ))}
    </div>
  );
};

const listings = [
  {
    id: 1,
    title: "Analyst Excel Master",
    path: "",
    location: "New York, NY"
  }
];

class Careers extends Component {
  constructor() {
    super();

    this.state = {
      jobListings: []
    };
  }

  render() {
    const { jobListings } = this.state;

    return (
      <div className="homepage careers">
        <Navbar />
        <div id="wrapper">
          <div id="page">
            <div id="content_container">
              <div className="center" id="content">
                <h1>Careers at Thelius Capital</h1>
                <AnchorLink className="btn btn-info" href="#current_openings">
                  Current Openings
                </AnchorLink>
              </div>
            </div>
          </div>
          <section className="job-openings">
            <div className="container">
              <div className="center" id="current_openings">
                <h2>Current Openings</h2>
                {jobListings.length ? (
                  <JobListings listings={jobListings} />
                ) : (
                  <h3>There are currently no job openings</h3>
                )}
              </div>
            </div>
          </section>
          <div className="footer">
            <div className="container-fluid">
              <div
                className="row"
                style={{ padding: "100px 0", background: "#f5f5f5" }}
              >
                <div className="col-sm-12">
                  <div className="text-center text-muted">
                    © 2019 Thelius Capital Partners LLC
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Careers;
